import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const muteApi = {
  /**
   * @param {string|number} conversationId
   * @param {'OFF'|'ALL'|'EXCEPT_MENTION'|boolean} muteModeOrMuted
   */
  set: (conversationId, muteModeOrMuted = 'ALL') => {
    const body =
      typeof muteModeOrMuted === 'boolean'
        ? { muted: muteModeOrMuted }
        : { muteMode: muteModeOrMuted };
    return imRequest.put(`${IM_API}/conversations/${conversationId}/mute`, body);
  },
};
